// This file contains compile-time defined variables.

export const LAUNCHERS = '#{LAUNCHERS}' as unknown as Readonly<{
	[key: string]: string;
}>;
